// Mileage Cost Options field labels
export const MILEAGE_FIELD_LABELS = {
    MILES_AT_INCEPTION: 'Miles at Inception',
    THRESHOLD_MILES: 'Threshold Miles',
    RETRO_MILES: 'Retro Miles',
    CHARGE_WHEN_OVER: 'Charge When Over',
    CHARGE_BACK_TO: 'Charge Back To',
    INCEPTION_RATE: 'Inception Rate',
    INITIAL_MILES_CHARGED: 'Initial Miles Charged',
    INITIAL_MILEAGE_CHARGE: 'Initial Mileage Charge',
    STANDARD_ALLOWED_MILES: 'Standard Allowed Miles',
    ANNUAL_MILES: 'Annual Miles',
    EXCESS_MILE_RATE: 'Excess Mile Rate',
    TOTAL_EXCESS_MILES_PURCHASED: 'Total Excess Miles Purchased',
    TERM_MONTHLY: 'Term (Monthly)',
    TOTAL_MILES: 'Total Miles',
    EXCESS_AMOUNT: 'Excess Amount',
    MILEAGE_PENALTY_RATE: 'Mileage Penalty Rate'
} as const;

// Field types
export const enum FIELD_TYPE {
    NUMERIC = 'numeric',
    CURRENCY = 'currency',
    TEXT = 'text',
    DROPDOWN = 'dropdown'
}

// Section titles
export const MILEAGE_SECTION_TITLES = {
    INITIAL_MILES: 'Initial Miles',
    ANNUAL_MILES: 'Annual Miles',
    PENALTY_MILES: 'Penalty Miles'
} as const;

// SlideOut titles
export const SLIDEOUT_TITLE = 'Mileage Cost Options and Residual Breakdown';

// Tab identifiers
export const TAB_IDS = {
    MILEAGE_COST_OPTIONS: 'mileageCostOptions',
    RESIDUAL_BREAKDOWN: 'residualBreakdown'
} as const;

// Tab labels
export const TAB_LABELS = {
    MILEAGE_COST_OPTIONS: 'Mileage Cost Options',
    RESIDUAL_BREAKDOWN: 'Residual Breakdown'
} as const;

// Residual field labels
export const RESIDUAL_FIELD_LABELS = {
    RESIDUAL_BASED_ON: 'Residual Based On',
    RESIDUAL_TYPE: 'Residual Type',
    BASE_RESIDUAL: 'Base residual',
    BASE_RESIDUAL_PERCENT: 'Base residual %',
    PROGRAM_ADJUSTMENT_PERCENT: 'Program Adjustment %',
    PROGRAM_RESIDUAL: 'Program residual',
    PROGRAM_RESIDUAL_PERCENT: 'Program residual %',
    RESIDUAL: 'Residual',
    RESIDUAL_PERCENT: 'Residual %',
    EXISTING_MILEAGE_COST: 'Existing Mileage Cost',
    PREPAID_MILEAGE_COST: 'Prepaid Mileage Cost',
    RESIDUALIZED_ACCESSORIES: 'Residualized Accessories',
    ADJUSTED_RESIDUAL: 'Adjusted Residual'
} as const;

// Residual section title
export const RESIDUAL_SECTION_TITLE = 'Residual Breakdown';

export const RESIDUAL_TYPE_TOGGLE_GROUP_ID = 'residualTypeToggle';
export const RESIDUAL_TYPE_TOGGLE_TESTID = 'residual-type-toggle';
export const RESIDUAL_TYPE_DOLLAR_TESTID = 'residual-type-dollar-toggle';
export const RESIDUAL_TYPE_PERCENT_TESTID = 'residual-type-percent-toggle';

export const DOLLAR_RESIDUAL_WARNING_TESTID = 'dollar-residual-warning';
export const DOLLAR_RESIDUAL_WARNING_MESSAGE =
    'Dollar-based residuals may not meet contracting requirements. Check your residual percent before submitting to contracting.';
